package com.kinoshazam.config

data class PlatformConfig(
    val platform: Platform,
    val version: String,
    val buildNumber: Long,
) {
    enum class Platform(val wireName: String) {
        ANDROID("android"),
        ANDROID_TV("android_tv"),
        IOS("ios"),
        WEB("web"),
        MAC_OS("mac_os"),
        WINDOWS("windows"),
        LINUX("linux"),
        UNKNOWN("unknown"),
    }
}

fun PlatformConfig.Platform.isAndroid() = this == PlatformConfig.Platform.ANDROID

fun PlatformConfig.Platform.isAndroidTv() = this == PlatformConfig.Platform.ANDROID_TV

fun PlatformConfig.Platform.isDesktop() =
    this == PlatformConfig.Platform.WINDOWS ||
        this == PlatformConfig.Platform.MAC_OS ||
        this == PlatformConfig.Platform.LINUX

fun PlatformConfig.Platform.isIOS() = this == PlatformConfig.Platform.IOS


expect fun getPlatformConfig(): PlatformConfig
